import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { OrderBy } from 'entities/tour/models/search-tour/models.ts'
import searchTourStore from 'entities/tour/models/search-tour/search-tour'

import {
  DEFAULT_TOUR_SORT_OPTION,
  TOUR_SORT_OPTIONS,
} from 'shared/constants/tours.ts'
import { HeaderResetButton } from 'shared/ui/header-reset-button'
import { RadioButton } from 'shared/ui/radio-button'

import s from './styles.module.scss'

const SortPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const currentSort = searchTourStore.orderBy

  const handleBack = () => navigate(-1)

  const handleSortChange = (value: string) => {
    searchTourStore.setOrderBy(value as OrderBy)
    handleBack()
  }

  const handleReset = () => {
    searchTourStore.resetOrderBy()
    handleBack()
  }

  const hasActiveSort = () => {
    return searchTourStore.orderBy !== DEFAULT_TOUR_SORT_OPTION
  }

  return (
    <div className={clsx(s.bgWhite)}>
      <HeaderResetButton
        title={t('tours_block.sort')}
        isIconBlack
        onBack={handleBack}
        onReset={handleReset}
        isCanDisable={hasActiveSort()}
      />

      <div className={s.sortContainer}>
        {TOUR_SORT_OPTIONS.map(({ value, labelKey }) => (
          <label
            key={value}
            className={s.radioLabel}
          >
            <RadioButton
              isActive={currentSort === value}
              onChange={() => handleSortChange(value)}
            />
            <span>{t(labelKey)}</span>
          </label>
        ))}
      </div>
    </div>
  )
})

export default SortPage
